<!--
 * @FileDescription: 现金银行（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-21（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="freight-top" @click="onAdd(1)" v-has="'finance_cash_add'">
                <img src="@/assets/image/xianjinyinhang.png"/>
                <span>新增现金银行</span>
            </div>
            <template v-if="dataSource.length > 0">
                <a-table :columns="columns"
                         :dataSource="dataSource"
                         :pagination="false"
                         :defaultExpandAllRows="true"
                         class="table-freight"
                         :scroll="{y:'calc(100vh - 310px)' }"
                         bordered
                         :rowClassName="rowClassName"
                         rowKey="id">
                    <template slot="state" slot-scope="text, record">
                            <span :class="text == 1 ? 'audit-state' : 'audit-state audit-state1'">
                                  <span class="audit-state-cir"></span>
                                  <span v-if="text == 1">正常</span>
                                   <span v-else>禁用</span>
                              </span>
                    </template>
                    <template slot="operation" slot-scope="text, record,index">
                        <span style="color: #387BFC;margin-right: 20px;cursor: pointer" v-if="!isEmpty(record.companyStoreId)" @click="onAdd(2,record)" v-has="'finance_cash_edit'">编辑</span>
                        <span style="color: #387BFC;margin-right: 20px;cursor: pointer" v-if="record.id !='1292705777642295300' && record.openFlag == 1" @click="onAdd(3,record)" v-has="'finance_cash_period_edit'">修改期初</span>
                        <span style="color: #387BFC;cursor: pointer" v-if="record.id !='1292705777642295300' && record.openFlag == 1" @click="onAdd(4,record)" v-has="'finance_cash_detail'">资金明细</span>
                    </template>
                </a-table>
            </template>
        </div>
        <freightModel ref="freightModel" @finceList="finceList"></freightModel>
    </div>
</template>

<script>
    import {finceaccountList,finacecondition} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    import freightModel from './model/freightModel'
    export default {
        mixins:[mixins],
        data(){
            return{
                tabIndex:1,
                columns: [
                    {
                        title: '',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 120,
                        align: 'center',
                        customRender(t, r, index) {
                            return parseInt(index) + 1
                        }
                    },
                    {
                        title: '科目编号',
                        key: 'code',
                        dataIndex: 'code',
                    },
                    {
                        title: '科目名称',
                        key: 'name',
                        dataIndex: 'name',
                    },
                    {
                        title: '科目简称',
                        key: 'nameShort',
                        dataIndex: 'nameShort',
                    },
                    {
                        title: '期初余额',
                        key: 'initialBalance',
                        align:'right',
                        dataIndex: 'initialBalance',
                    },
                    {
                        title: '期末余额',
                        key: 'ultimateBalance',
                        align:'right',
                        dataIndex: 'ultimateBalance',
                    },
                    {
                        title: '状态',
                        key: 'openFlag',
                        dataIndex: 'openFlag',
                        scopedSlots: { customRender: 'state' }
                    },
                    {
                        title: '备注',
                        key: 'remark',
                        dataIndex: 'remark',
                    },
                    {
                        title: '操作',
                        width:250,
                        dataIndex: 'operation',
                        scopedSlots: { customRender: 'operation' }
                    },
                ],
                dataSource: [],
            }
        },
        watch: {

        },
        mounted () {
            this.getList()
        },
        created () {

        },
        components: {
            freightModel,

        },
        methods: {
            getList(){
                this.$store.state.isLoding = true
                this.dataSource = []
                let data = {
                    companyStoreId:this.$store.state.shopId
                }
                data =   this.$qs.stringify(data)
                finceaccountList(data,{}).then((res)=>{
                    if(res.success){
                        console.log(res.result)
                        res.result.forEach((item)=>{
                            if(item.children.length == 0){
                                delete item.children
                            }else{
                                item.children.forEach((item1)=>{
                                    if(item1.children.length == 0){
                                        delete item1.children
                                    }
                                })
                            }
                        })
                        this.dataSource = res.result
                        this.$store.state.isLoding = false
                    }
                })
            },
            /**
             * @description: tab行的类名（方法描述）
             */
            rowClassName(record,index){
                let className = ''
                if(record.openFlag != 1){
                    className = 'tab-row-warn'
                }
                return className
            },
            /**
             * @description: 此为方法注释（方法描述）
             * @param {参数类型} 参数名称
             * @return void
             */
            onAdd(index,record){
                if(index == 1){
                    let code = ''
                    if(this.dataSource[0].children.length == 0){
                        code = 0
                    }else{
                        code = parseInt(this.dataSource[0].children[0].code)+1
                    }
                    this.$refs.freightModel.onOpen(3,{},index,code)
                }else if(index==2){
                    this.$refs.freightModel.onOpen(3,record,index)
                }else if(index == 3){
                    this.$refs.freightModel.onOpen(6,record)
                }else if(index == 4){
                    this.$refs.freightModel.onOpen(5,record)
                }

            },
            /**
             * @description: 弹框回调（方法描述）
             */
            finceList(){
                this.getList()
            }
        },

    }
</script>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    .freight-top{
        cursor: pointer;
        width: 200px;
        padding: 20px 0 20px 30px;
        color: var(--co);
        img{
            width: 40px;
            margin-right: 8px;
        }
    }

}
</style>


